export const BUSINESS_LANDING_PAGE_URL = '/join';
